/** 
*@author: Sirisha.M
*@Description : 
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { API_RUBUSMASTERS } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { UpdateMasters, CreateMasters, deleteMasters } from '../../APICalls';
import { Form, Input, message, Button, Drawer, Tooltip, Popconfirm } from 'antd';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';
import translation from '../../Utils/translation';

const ApiList = {
  CreateAssetType: `${API_RUBUSMASTERS.AssetTypeCREATE}`,
  UpdateAssetType: `${API_RUBUSMASTERS.AssetTypeUPDATE}`,
  DeleteAssetType: `${API_RUBUSMASTERS.AssetTypeDELETE}`
};

const AssetTypes = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleAttributes, setVisibleAttributes] = useState(false);
  const [translationCache, setTranslationCache] = useState(props.translationCache);
  const hForm = useRef(null);

  useEffect(() => {
    _getList();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache, translationCache]);


  const _getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = `${API_RUBUSMASTERS.AssetType_Get}?SiteId=${siteId}`;

    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(orgHeaders)
      .then((response) => {
        setList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setVisibleAttributes(true);
    setFormObject(record);
  };

  const deleteRecord = async (id) => {
    let deleteResponse = await deleteMasters(ApiList.DeleteAssetType, id);
    message.success(deleteResponse && deleteResponse.message);
    _getList();
  };

  const onFinish = async () => {
    hForm.current &&
      hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(
              ApiList.UpdateAssetType,
              payload,
              formObject.Id
            );
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let createResponse = await CreateMasters(ApiList.CreateAssetType, payload);
            message.success(createResponse && createResponse.message);
          }
          _getList();
          hForm.current &&
            hForm.current.setFieldsValue({
              Code: null,
              Name: null,
              ModuleCode: null,
              MaxLimit: null
            });
          setFormObject({});
          setVisibleAttributes(false);
        })
        .catch((error) => {
          console.log(error);
        });
  };

  const OpenDrawer = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        ModuleCode: null,
        MaxLimit: null
      });
    let formObject = {
      Code: null,
      Name: null,
      ModuleCode: null,
      MaxLimit: null
    };
    setVisibleAttributes(true);
    setFormObject(formObject);
  };

  const onClose = () => {
    hForm.current &&
      hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        ModuleCode: null,
        MaxLimit: null
      });
    setVisibleAttributes(false);
    setFormObject({});
  };

  const columns = [
    {
      title: translation(translationCache, 'Module Code'),
      dataIndex: 'ModuleCode',
      key: 'ModuleCode'
    },
    {
      title: translation(translationCache, 'Name'),
      dataIndex: 'Name',
      key: 'Name'
    },
    {
      title: translation(translationCache, 'Action'),
      dataIndex: 'Action',
      render: (text, record) => (
        <>
          <Button onClick={() => _editRecord(record)} >
            <Tooltip title={translation(translationCache, "Edit")}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, 'Are You Sure That You Want To Delete')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteRecord(record.Id)}
            okText={translation(translationCache, 'yes')}
            cancelText={translation(translationCache, 'No')}
          >
            <Button >
              <span>
                <Tooltip title={translation(translationCache, 'Delete')}>
                  <DeleteOutlined />
                </Tooltip>
              </span>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <div style={{ minHeight: window.innerHeight - 143 }}>
      <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
        <Button type="primary" onClick={OpenDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add AssetTypes')}
        </Button>
      </div>
      <StyledTable size="small"
        columns={columns}
        dataSource={list}
        pagination={
          list.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update AssetTypes')
            : translation(translationCache, 'Add AssetTypes')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleAttributes}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Code')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'ModuleCode')}
            name="ModuleCode"
            rules={[{ required: true, message: translation(translationCache, 'Please select ModuleCode') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter ModuleCode')} />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, 'MaxLimit')}
            name="MaxLimit"
            rules={[{ required: true, message: translation(translationCache, 'Please enter MaxLimit !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter MaxLimit')} />
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>
          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(AssetTypes);
